import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  injectIntl,
  FormattedTime as FormattedTimeOriginal
} from 'react-intl'
import moment from 'moment'
import styles from './formatted-time.styl'

@injectIntl
class FormattedTime extends Component {
  static propTypes = {
    value: PropTypes.any.isRequired,
    intl: PropTypes.object,
    spaceAfter: PropTypes.bool
  }

  render() {
    const {
      value,
      intl,
      spaceAfter
    } = this.props
    const isArabic = intl.locale === 'ar'
    const spaceAfterClass = isArabic && spaceAfter ? styles.arabicSpaceAfter : ''

    return (
      <span className={`${spaceAfterClass}`}>
        { isArabic && moment(value).format('LT') }
        { !isArabic && <FormattedTimeOriginal {...this.props} /> }
      </span>
    )
  }
}

export default FormattedTime
